module.exports = __webpack_public_path__ + "static/icon-48950dd72df0490c2310125f3115d48b.png";